import { useContext } from 'react';
import { SidebarContext } from '../contexts';

export const useSidebar = () => {
  const { collapsed, handleToggle } = useContext(SidebarContext);
  return { collapsed, handleToggle };
};
